/**
 * Apps tab on dashboard's sidebar
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import DashboardTab from './DashboardTab'
import DashboardCard from './DashboardCard'
import { getTemplateByApp, getTemplateInfo } from 'templates/templates'

class AppsTab extends Component {
  render () {
    const { apps, selectedAppId, selectApp } = this.props

    return (
      <DashboardTab>
        {apps.map(card => {
          const template = getTemplateByApp(card)
          const info = getTemplateInfo(template.id)
          const image = _.get(card.customFields, info.thumbnailPath, _.get(template.settings, info.thumbnailPath))
          return (
            <DashboardCard
              id={card.id}
              type='app'
              image={image}
              title={card.title}
              published={Boolean(card.published)}
              lastModified={card.lastModified}
              integrations={card.integrations}
              selected={selectedAppId === card.id}
              selectCard={selectApp}
              key={card.id}
            />
          )
        })}
      </DashboardTab>
    )
  }
}

AppsTab.propTypes = {
  apps: PropTypes.array,
  selectedAppId: PropTypes.string,
  selectApp: PropTypes.func,
}

export default AppsTab



// WEBPACK FOOTER //
// ./src/components/dashboard/AppsTab.js